var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('div',{staticClass:"user-base-balloon",style:(_vm.style)},[_c('Balloon',{attrs:{"direction":_vm.balloonDirection,"adjust":_vm.adjust}},[_c('div',{staticClass:"user-base-balloon__inner"},[_vm._t("default")],2)])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }